import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_BA.json';
import exercises from './FITNESS_EXERCISES_BA.json';
import recipes from './FITNESS_RECIPES_BA.json';

export const FITNESS_DATA_BA: ServiceData = {
  articles,
  exercises,
  recipes,
};
